'use client';

import { THEME } from '@/constants';
import { useTheme } from '@/hooks';
import { useMount } from '@/hooks/use-mount';
import { ImageProps } from 'next/image';
import { Img } from './image';

interface ThemeableImageProps extends Omit<ImageProps, 'src'> {
  darkSrc: string;
  lightSrc: string;
}

export const ThemeableImage = (props: ThemeableImageProps) => {
  const { darkSrc, lightSrc, width, height, className, ...rest } = props;
  const { theme } = useTheme();
  const { mount } = useMount();

  return <Img src={mount && theme === THEME.LIGHT ? lightSrc : darkSrc} {...{ width, height, className }} {...rest} />;
};
